import React from 'react';
import { Mail, Phone, MapPin, Clock, MessageCircle } from 'lucide-react';
import { ContactForm } from '../components/ContactForm';
interface KontaktPageProps {
  onNavigate: (page: string) => void;
}
export function KontaktPage({
  onNavigate
}: KontaktPageProps) {
  return <div className="min-h-screen bg-slate-50" data-id="element-461">
      <div className="bg-white py-20 border-b border-slate-200" data-id="element-462">
        <div className="container mx-auto px-4 text-center" data-id="element-463">
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-464">
            Kontakt
          </h1>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed" data-id="element-465">
            Wir sind für Sie da. Schreiben Sie uns oder rufen Sie an. Unser Team
            freut sich auf Sie.
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-20" data-id="element-466">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-467">
          <div className="space-y-10" data-id="element-468">
            <div data-id="element-469">
              <h2 className="text-3xl font-bold text-slate-900 mb-8" data-id="element-470">
                So erreichen Sie uns
              </h2>
              <div className="space-y-8" data-id="element-471">
                <div className="flex items-start gap-6 group" data-id="element-472">
                  <div className="p-4 bg-blue-100 rounded-2xl text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-colors shadow-sm" data-id="element-473">
                    <Phone className="h-6 w-6" data-id="element-474" />
                  </div>
                  <div data-id="element-475">
                    <h3 className="font-bold text-xl text-slate-900 mb-1" data-id="element-476">
                      Telefon
                    </h3>
                    <p className="text-slate-600 text-lg" data-id="element-477">
                      +49 (0) 30 12345678
                    </p>
                    <p className="text-sm text-slate-500 mt-1" data-id="element-478">
                      Mo-Fr, 09:00 - 18:00 Uhr
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-6 group" data-id="element-479">
                  <div className="p-4 bg-blue-100 rounded-2xl text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-colors shadow-sm" data-id="element-480">
                    <Mail className="h-6 w-6" data-id="element-481" />
                  </div>
                  <div data-id="element-482">
                    <h3 className="font-bold text-xl text-slate-900 mb-1" data-id="element-483">
                      E-Mail
                    </h3>
                    <p className="text-slate-600 text-lg" data-id="element-484">
                      service@smartprotect24.de
                    </p>
                    <p className="text-sm text-slate-500 mt-1" data-id="element-485">
                      Antwort innerhalb von 24h
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-6 group" data-id="element-486">
                  <div className="p-4 bg-blue-100 rounded-2xl text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-colors shadow-sm" data-id="element-487">
                    <MapPin className="h-6 w-6" data-id="element-488" />
                  </div>
                  <div data-id="element-489">
                    <h3 className="font-bold text-xl text-slate-900 mb-1" data-id="element-490">
                      Anschrift
                    </h3>
                    <p className="text-slate-600 text-lg leading-relaxed" data-id="element-491">
                      SmartProtect24 GmbH
                      <br data-id="element-492" />
                      Premium Plaza 1<br data-id="element-493" />
                      10115 Berlin
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg border border-slate-100" data-id="element-494">
              <h3 className="font-bold text-xl mb-6 flex items-center gap-3 text-slate-900" data-id="element-495">
                <Clock className="h-6 w-6 text-blue-500" data-id="element-496" /> Öffnungszeiten
              </h3>
              <div className="space-y-4 text-slate-600" data-id="element-497">
                <div className="flex justify-between border-b border-slate-100 pb-3" data-id="element-498">
                  <span className="font-medium" data-id="element-499">Montag - Freitag</span>
                  <span className="font-bold text-slate-900" data-id="element-500">
                    09:00 - 18:00
                  </span>
                </div>
                <div className="flex justify-between border-b border-slate-100 pb-3" data-id="element-501">
                  <span className="font-medium" data-id="element-502">Samstag</span>
                  <span className="font-bold text-slate-900" data-id="element-503">
                    10:00 - 14:00
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-504">
                  <span className="font-medium" data-id="element-505">Sonntag</span>
                  <span className="font-bold text-slate-400" data-id="element-506">Geschlossen</span>
                </div>
              </div>
            </div>
          </div>

          <div data-id="element-507">
            <ContactForm data-id="element-508" />
          </div>
        </div>
      </div>
    </div>;
}